module.exports = __webpack_public_path__ + "static/media/ic-copy.9065a619.svg";